import React, { useEffect, useState } from 'react';
interface CountdownProps {
  className?: string;
}
export function Countdown({
  className = ''
}: CountdownProps) {
  const [time, setTime] = useState({
    hours: 21,
    minutes: 38,
    seconds: 40
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <span className={className} data-id="element-117">
      {String(time.hours).padStart(2, '0')} Horas :{' '}
      {String(time.minutes).padStart(2, '0')} Min :{' '}
      {String(time.seconds).padStart(2, '0')} Seg
    </span>;
}